<script setup lang="ts">
/** Zone de texte (note, motif). Même habillage que TextField, compteur de caractères. */
import { useId } from 'vue'

import Field from './Field.vue'

withDefaults(
  defineProps<{
    label: string
    placeholder?: string
    hint?: string
    error?: string
    maxlength?: number
    rows?: number
  }>(),
  { placeholder: undefined, hint: undefined, error: undefined, maxlength: 500, rows: 3 },
)

const model = defineModel<string>({ default: '' })
const id = useId()
</script>

<template>
  <Field :id="id" :label="label" :hint="hint" :error="error">
    <template #default="{ describedBy }">
      <div
        :class="[
          'rounded-control bg-surface px-4 py-3 focus-within:outline-2 focus-within:outline-offset-2',
          error
            ? 'outline-2 outline-danger focus-within:outline-danger'
            : 'focus-within:outline-accent',
        ]"
      >
        <textarea
          :id="id"
          v-model="model"
          :rows="rows"
          :maxlength="maxlength"
          :placeholder="placeholder"
          :aria-invalid="error ? 'true' : undefined"
          :aria-describedby="describedBy"
          class="block w-full resize-none bg-transparent text-input text-ink outline-none placeholder:text-ink-muted"
        />
        <p class="text-right text-caption text-ink-muted tabular-nums" aria-hidden="true">
          {{ model.length }}&nbsp;/&nbsp;{{ maxlength }}
        </p>
      </div>
    </template>
  </Field>
</template>
